import { assignInlineVars } from "@vanilla-extract/dynamic";
import Link from "plos/src/components/links/Link";
import {
  alignStyle,
  entryLink,
  managerName,
  matchEntryWrapper,
  teamName,
} from "./matchEntry.css";

interface MatchEntryProps {
  link: string;
  entry: number;
  entryName: string;
  playerName: string;
  align: "left" | "right";
}

const MatchEntry = ({
  link,
  entry,
  entryName,
  playerName,
  align,
}: MatchEntryProps) => {
  return (
    <div
      className={matchEntryWrapper}
      style={assignInlineVars({ [alignStyle]: align })}
    >
      {entry ? (
        <Link to={link} className={entryLink}>
          <strong className={managerName}>{playerName}</strong>
          <div className={teamName}>{entryName}</div>
        </Link>
      ) : (
        <>&nbsp;</>
      )}
    </div>
  );
};

export default MatchEntry;
